import React, { ReactNode } from "react";
import { ModalNames, State } from "../state";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";

export interface ToggleModalOptions {
  setState: React.Dispatch<React.SetStateAction<State>>;
  name: ModalNames;
}
export function toggleModal(options: ToggleModalOptions) {
  options.setState((prevState: State) => {
    return {
      ...prevState,
      openModals: {
        ...prevState.openModals,
        [options.name]: !prevState.openModals[options.name],
      },
    };
  });
}

export interface ModalOptions {
  component: ReactNode;
  name: ModalNames;
  setState: React.Dispatch<React.SetStateAction<State>>;
  state: State;
  style?: Record<string, any>;
  alignItems?: string;
  id?: string;
}

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "95%",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  placeItems: "center",
};

export function BaseModal(options: ModalOptions) {
  const name = options.name;
  const setState = options.setState;
  const state = options.state;

  const handleClose = () => {
    setState((prevState: State) => {
      const selectedUpdate =
        (prevState.openModals.newRecipe || prevState.openModals.recipeBook) &&
        prevState.openModals.recipeCard
          ? {}
          : { selected: false };
      const updatedMenu = Object.fromEntries(
        Object.entries(prevState.menu).map(([date, menuItem]) => [
          date,
          { ...menuItem, ...selectedUpdate },
        ]),
      );
      return {
        ...prevState,
        menu: updatedMenu,
        openModals: {
          ...prevState.openModals,
          [name]: false,
        },
        selectedRecipe: undefined,
      };
    });
  };

  return (
    <>
      <Modal
        open={state.openModals[name]}
        onClose={handleClose}
        aria-labelledby={`modal-${name}`}
        aria-describedby={`modal-${name}`}
        id={`${options.id}-modal`}
      >
        <Box
          sx={{
            ...modalStyle,
            ...(options.style ?? {}),
          }}
          id={`${options.id}-box`}
        >
          <Grid
            alignItems={options.alignItems ?? "right"}
            id={`${options.id}-grid`}
            sx={{
              width: "100%",
              height: "100%",
            }}
          >
            <CloseIcon
              sx={{
                zIndex: 1111,
              }}
              onClick={handleClose}
              id={`${options.id}-close`}
            />
          </Grid>
          {options.component}
        </Box>
      </Modal>
    </>
  );
}
